import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48.353",
  height: "34.704",
  viewBox: "0 0 12.793 9.182"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M95.78 67.409c.133-.071.142-.102.047-.16-.097-.061-.083-.17.081-.648 1.039-3.004 2.547-5.95 3.558-6.948.704-.695.929-.804 1.676-.814.534-.008.634.017.827.197.121.114.26.352.307.53.193.717-.33 2.314-.958 2.924-.39.38-1.09.785-1.355.785-.26 0-.79-.587-.857-.95-.126-.68.093-1.061 1.092-1.903.34-.285.388-.356.247-.36-.293-.007-1.178.867-1.47 1.45-.384.769-.312 1.539.174 1.88.225.157 1.039.186 1.517.053 1.544-.429 2.69-2.775 2.016-4.127-.266-.535-.585-.71-1.297-.71-1.365 0-2.292.874-3.763 3.55-.509.925-1.484 3.151-1.705 3.89-.16.538-.221.436-.152-.254.092-.919.086-4.55-.008-4.55-.07 0-.932 1.218-2.127 3.005-.218.326-.61.973-.872 1.439-.263.465-.477.82-.477.788s.114-.523.252-1.091c.376-1.54 1.004-5.58.911-5.86-.02-.057-.083-.009-.146.11-.061.116-.536.745-1.055 1.397-1.922 2.413-2.28 2.875-2.125 2.751.087-.07.67-.767 1.297-1.55.626-.782 1.153-1.409 1.17-1.391.059.058-1.07 5.83-1.283 6.556l-.054.185.508-.154c.644-.195.75-.257.599-.35-.09-.056-.06-.182.155-.617.535-1.084 2.437-4.02 2.539-3.918.072.072-.176 4.837-.268 5.125-.051.162-.045.162.392-.004.244-.093.518-.208.608-.256",
  style: {"display":"inline","fill":"#fcc707","stroke-width":".0846667","fill-opacity":"1"},
  transform: "translate(-90.086 -58.608)"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }